import { GaTracking, MfSegmentTracking } from '@westwing/appshell_types';
import { useAppShell } from './context';

export enum TRACKING_IDS_PAGE_LABELS {
    LANDING = 'ids_landing',
    OVERSTEP = 'ids_overstep',
    QUESTIONNAIRE = 'ids_questionnaire',
}

export const useGaTracking = (): GaTracking => {
    const { trackingHelpers } = useAppShell();

    return { ...trackingHelpers.ga };
};

export const useSegmentTracking = (): MfSegmentTracking => {
    const { trackingHelpers } = useAppShell();

    return { ...trackingHelpers.segment };
};
